const MEDIA_ITEMS = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20movie%20scene%20thumbnail%20with%20two%20actors%20in%20tense%20confrontation%20in%20a%20dark%20room%2C%20warm%20cinematic%20lighting%2C%20film%20grain%2C%20movie%20poster%20style%2C%20high%20contrast&width=640&height=360&seq=media-01&orientation=landscape',
    title: '狂飙：年度扫黑神剧深度解析',
    type: '剧集解读',
    duration: '15分钟',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20sci-fi%20scene%20thumbnail%20with%20futuristic%20technology%20and%20cosmic%20landscape%2C%20deep%20space%20colors%2C%20cinematic%20composition%2C%20movie%20poster%20aesthetic%2C%20vibrant%20neon%20accents&width=640&height=360&seq=media-02&orientation=landscape',
    title: '三体：从小说到荧幕的视觉奇迹',
    type: '幕后揭秘',
    duration: '20分钟',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20Shanghai%20cityscape%20at%20night%20with%20neon%20signs%20and%20wet%20streets%2C%201980s%20aesthetic%2C%20warm%20golden%20tones%2C%20cinematic%20mood%2C%20film%20poster%20quality&width=640&height=360&seq=media-03&orientation=landscape',
    title: '繁花：王家卫镜头下的上海往事',
    type: '导演风格',
    duration: '18分钟',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=An%20anime%20style%20action%20scene%20thumbnail%20with%20dynamic%20sword%20fight%20and%20flame%20effects%2C%20Japanese%20warrior%2C%20vibrant%20animation%20colors%2C%20cinematic%20composition%2C%20high%20quality%20art&width=640&height=360&seq=media-04&orientation=landscape',
    title: '鬼灭之刃锻刀村篇制作特辑',
    type: '动漫赏析',
    duration: '12分钟',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cinematic%20thumbnail%20of%20fighter%20jets%20in%20golden%20sunset%20sky%2C%20heroic%20aerial%20photography%2C%20warm%20dramatic%20lighting%2C%20film%20poster%20style%2C%20Chinese%20movie%20aesthetic&width=640&height=360&seq=media-05&orientation=landscape',
    title: '长空之王：中国试飞员的热血传奇',
    type: '真实故事',
    duration: '14分钟',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">影视解读</h2>
          <p className="text-sm text-foreground-500 mt-2">深度解析热门影视，了解更多幕后故事</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {MEDIA_ITEMS.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl overflow-hidden bg-background-100 group cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="relative h-[180px] md:h-[200px] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent" />
                <div className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-background-950/70 text-background-50 text-xs px-2 py-1 rounded-full">
                  <i className="ri-play-circle-line text-sm" />
                  <span>{item.duration}</span>
                </div>
              </div>
              <div className="p-4">
                <span className="text-[10px] font-semibold text-primary-500 bg-primary-100/70 px-2 py-0.5 rounded-full mb-2 inline-block">
                  {item.type}
                </span>
                <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 font-heading">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}